import { Icons } from '@/components/icons';
import { Typography } from '@/components/primitives/Typography';
import { TransText } from '@/i18n/trans/text';
import type { ServiceAttributeDTO } from '@/types/dto/agent';
import type { FC } from 'react';

interface ServiceTextMessageProps {
  serviceTexts: Array<ServiceAttributeDTO>;
}

const ServiceTextMessage: FC<ServiceTextMessageProps> = ({ serviceTexts }) => {
  if (!serviceTexts.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 rounded border border-warning-border bg-warning-surface p-3 text-dark">
      <div className="flex gap-3">
        <Icons.infoCircle height={20} width={20} />
        <Typography variant="subtitle">
          {serviceTexts?.length === 1 ? (
            serviceTexts[0].shortDescription
          ) : (
            <TransText i18nKey="importantInformation" />
          )}
        </Typography>
      </div>
      {serviceTexts?.map(({ description }, key) => (
        <Typography key={key} variant="paragraph">
          {description}
        </Typography>
      ))}
    </div>
  );
};

export default ServiceTextMessage;
